import React, { FC, useEffect, useState } from 'react';
import {AEAGrid} from '@components/';
import styles from './csv-by-country.module.scss';
import { MainBudgetPresenter } from '@presenters/screens/main-budget.presenter';
import { IMainBudget } from '@interfaces/screens/main-budget.interface';

const CsvByCountry: FC<any> = () => {

    const [dataColumns, setDataColumns] = useState(null);
    const [dataSource, setDataSource] = useState([]);

    const view: IMainBudget = { state: {
        dataSource,
        dataColumns,
        setDataColumns,
        setDataSource
     } };
    const presenter = new MainBudgetPresenter(view);

    useEffect(() => {
        presenter.initializeCSVByCountry();
    }, []);
 

    return (
        <div>
            <div className={styles.mssUpdate}>{presenter.lastUpdateDate}</div>
            <AEAGrid
                {...presenter.dsCSVByCountryProps}>
            </AEAGrid>
        </div>
    )
}

export default CsvByCountry;